module.exports = __webpack_public_path__ + "img/edit_icon.0f2970cc.svg";